import { H4, Image, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service/DynamicImage";
import BlogDetails from "./BlogDetails";
import { CommentTitleLearning, LearningCommentOne, LearningCommentTwo } from "../../../../Constant";
import UserComment from "../../../Blog/BlogSingle/common/UserComment";

const BlogSingle = () => {
  return (
    <div className="blog-single">
      <div className="blog-box blog-details">
        <Image className="img-fluid w-100" src={dynamicImage("faq/learning-1.png")} alt="blog-main" />
        <BlogDetails />
      </div>
      <section className="comment-box">
        <H4>{CommentTitleLearning}</H4>
        <hr />
        <UL className="simple-list">
          <UserComment ImageSrc="comment.jpg" userReplay text={LearningCommentOne} />
          <UserComment ImageSrc="9.jpg" text={LearningCommentTwo} />
        </UL>
      </section>
    </div>
  );
};

export default BlogSingle;
